<template>
    <div class="w-full h-[400vw] px-[2.5vw] pt-[8.3vw] relative bg-[#171717]">
        <div ref="textChallengeRef"
            class="text-challengen absolute top-[8.3vw] transition-all duration-500 ease-in-out opacity-1">
            <p class="text-white text-[12vw] font-emeritus">Challegen</p>
            <p class="w-[95vw] text-white text-[3.72vw] font-league font-semibold">
                Step into the endless Boss Stage series, where each victory is just the beginning of the next challenge.
                Each boss possesses unique skills and strategies — only the strongest, wisely upgraded team can advance
                further. How far will you go before needing to return to upgrade and rematch?
            </p>
        </div>

        <div ref="textAdventureRef"
            class="text-adventure absolute top-[8.3vw] transition-all duration-500 ease-in-out opacity-0">
            <p class="text-white text-[12vw] font-emeritus">Adventure</p>
            <p class="w-[95vw] text-white text-[3.72vw] font-league font-semibold">
                Adventure takes you into harsh dungeons, where each
                battle requires careful preparation of your
                team composition, strength and strategy. Smartly combining hero types, exploiting enemy
                weakness, and coordinating skills are the keys to overcoming the toughest challenges.
            </p>
        </div>

        <!-- Content Feedback-->
        <div class="h-[60vw] mt-[3.5vw] w-[95vw] absolute top-[60vw]">
            <div ref="imageChallengeRef"
                class="image-challengen transition-all duration-500 ease-in-out h-[60vw] flex flex-row space-x-[2vw] w-[95vw] absolute visible">
                <img src="../../assets/img/Desktop/FirestormArena/1.webp" alt="" class="h-full">
                <img src="../../assets/img/Desktop/FirestormArena/5.webp" alt="" class="h-full">
                <img src="../../assets/img/Desktop/FirestormArena/3.webp" alt="" class="h-full">
            </div>
            <div ref="imageAdventureRef"
                class="image-adventure transition-all duration-500 ease-in-out h-[60vw] flex flex-row space-x-[2vw] w-[95vw] absolute hidden">
                <img src="../../assets/img/Desktop/FirestormArena/2.webp" alt="" class="h-full">
                <img src="../../assets/img/Desktop/FirestormArena/6.webp" alt="" class="h-full">
                <img src="../../assets/img/Desktop/FirestormArena/4.webp" alt="" class="h-full">
            </div>
        </div> 

        <!-- Button and feedback content -->
        <div class="absolute top-[130vw] w-[95vw] flex justify-center">
            <img src="../../assets/img/Mobile/Union.webp" alt="" class="w-[95vw]">
            <div class="absolute top-[8vw] left-[8vw] w-[60vw] h-[25vw] flex flex-col justify-between">
                <div ref="buttonChallengeRef" @click="handleChallengeClick"
                    class="button-challengen transition-all duration-500 ease-in-out w-[50vw] h-[10.46vw] rounded-full bg-[#171717] flex flex-row justify-between items-center px-[7vw]">
                    <p class="text-[4.65vw] text-white font-league font-bold">Challegen</p>
                    <img src="../../assets/img/Desktop/Challegen/arrow.webp" alt="" class="w-[5.5vw] h-[5.5vw]">
                </div>
                <div ref="buttonAdventureRef" @click="handleAdventureClick"
                    class="button-challengen transition-all duration-500 ease-in-out w-[50vw] h-[10.46vw] rounded-full  flex flex-row justify-between items-center px-[7vw]">
                    <p class="text-[4.65vw] text-white font-league font-bold">Adventure</p>
                    <img src="../../assets/img/Desktop/Challegen/arrow.webp" alt="" class="w-[5.5vw] h-[5.5vw]">
                </div>
            </div>

            <!-- Content feedback -->
            <div class="absolute top-[40vw] w-[90vw]">
                <p class="text-[#171717] text-[12vw] font-emeritus">Feedback</p>
                <p class="w-[90vw] text-[#171717] font-league text-[3.25vw] font-semibold">
                    We’ve already received great feedback from our early access community. Join Idle Glory today and
                    help build an epic gaming community together!
                </p>

                <!-- Comment 1 -->
                <div class="mt-[6.5vw] w-[90vw] h-[9.4vw] bg-[#171717] rounded-full flex flex-row justify-between items-center pr-[3.25vw] pl-[1.7vw]">
                    <div class="flex flex-row items-center">
                        <img src="../../assets/img/Desktop/Challegen/discord.webp" alt="" class="w-[6vw] h-[6vw]">
                        <p class="font-league text-[4.06vw] text-white font-bold ml-[0.5vw]">LunaFox#8831</p>
                    </div>
                    <div class="flex flex-row items-center space-x-[1vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                    </div>
                </div>
                <p class="w-[90vw] text-[3.25vw] font-league font-semibold text-[#171717] mt-[2vw]">
                    "Lighting and boss fights are 🔥🔥🔥. Idk how an idle game got me this hooked tbh."
                </p>

                <!-- Comment 2 -->
                <div class="mt-[6.5vw] w-[90vw] h-[9.4vw] bg-[#171717] rounded-full flex flex-row justify-between items-center pr-[3.25vw] pl-[1.7vw]">
                    <div class="flex flex-row items-center">
                        <img src="../../assets/img/Desktop/Challegen/discord.webp" alt="" class="w-[6vw] h-[6vw]">
                        <p class="font-league text-[4.06vw] text-white font-bold ml-[0.5vw]">IronClaw#1923</p>
                    </div>
                    <div class="flex flex-row items-center space-x-[1vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                    </div>
                </div>
                <p class="w-[90vw] text-[3.25vw] font-league font-semibold text-[#171717] mt-[2vw]">
                    "Adventure mode is like... brain fried 😵‍💫 one wrong comp and you're 100% wiped lmao."
                </p>

                <!-- Comment 3 -->
                <div class="mt-[6.5vw] w-[90vw] h-[9.4vw] bg-[#171717] rounded-full flex flex-row justify-between items-center pr-[3.25vw] pl-[1.7vw]">
                    <div class="flex flex-row items-center">
                        <img src="../../assets/img/Desktop/Challegen/discord.webp" alt="" class="w-[6vw] h-[6vw]">
                        <p class="font-league text-[4.06vw] text-white font-bold ml-[0.5vw]">MysticBear#6654</p>
                    </div>
                    <div class="flex flex-row items-center space-x-[1vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                    </div>
                </div>
                <p class="w-[90vw] text-[3.25vw] font-league font-semibold text-[#171717] mt-[2vw]">
                    "Idle Glory got that cute fantasy vibe 🤩 but the gameplay’s actually kinda deep. Lvling up the squad is super gud lol."
                </p>

                <!-- Comment 4 -->
                <div class="mt-[6.5vw] w-[90vw] h-[9.4vw] bg-[#171717] rounded-full flex flex-row justify-between items-center pr-[3.25vw] pl-[1.7vw]">
                    <div class="flex flex-row items-center">
                        <img src="../../assets/img/Desktop/Challegen/reddit.webp" alt="" class="w-[6vw] h-[6vw]">
                        <p class="font-league text-[4.06vw] text-white font-bold ml-[0.5vw]">u/PixelPaladin</p>
                    </div>
                    <div class="flex flex-row items-center space-x-[1vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                    </div>
                </div>
                <p class="w-[90vw] text-[3.25vw] font-league font-semibold text-[#171717] mt-[2vw]">
                    "Fr tho, Idle Glory artstyle is hella charming 🔥 like, it's cute af but still feels kinda epic at the same time lol."
                </p>

                <!-- Comment 5 -->
                <div class="mt-[6.5vw] w-[90vw] h-[9.4vw] bg-[#171717] rounded-full flex flex-row justify-between items-center pr-[3.25vw] pl-[1.7vw]">
                    <div class="flex flex-row items-center">
                        <img src="../../assets/img/Desktop/Challegen/discord.webp" alt="" class="w-[6vw] h-[6vw]">
                        <p class="font-league text-[4.06vw] text-white font-bold ml-[0.5vw]">u/StrategicSloth</p>
                    </div>
                    <div class="flex flex-row items-center space-x-[1vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                    </div>
                </div>
                <p class="w-[90vw] text-[3.25vw] font-league font-semibold text-[#171717] mt-[2vw]">
                    "Finally an idle RPG where team synergy actually matters 🙌. Love messing around with diff hero comps tbh."
                </p>

                <!-- Comment 6 -->
                <div class="mt-[6.5vw] w-[90vw] h-[9.4vw] bg-[#171717] rounded-full flex flex-row justify-between items-center pr-[3.25vw] pl-[1.7vw]">
                    <div class="flex flex-row items-center">
                        <img src="../../assets/img/Desktop/Challegen/discord.webp" alt="" class="w-[6vw] h-[6vw]">
                        <p class="font-league text-[4.06vw] text-white font-bold ml-[0.5vw]">u/ManaGrind</p>
                    </div>
                    <div class="flex flex-row items-center space-x-[1vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                        <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[3.25vw] h-[3.25vw]">
                    </div>
                </div>
                <p class="w-[90vw] text-[3.25vw] font-league font-semibold text-[#171717] mt-[2vw]">
                    "The challenge stages hit diff 😭. You slam into that wall, upgrade your squad, and BOOM — so damn satisfying lmao."
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const buttonAdventureRef = ref(null);
const buttonChallengeRef = ref(null);
const textAdventureRef = ref(null);
const textChallengeRef = ref(null);
const imageChallengeRef = ref(null);
const imageAdventureRef = ref(null);

const bgActiveClass = 'bg-[#171717]';

const handleChallengeClick = () => {
    if (buttonAdventureRef.value && buttonChallengeRef.value &&
        textAdventureRef.value && textChallengeRef.value &&
        imageChallengeRef.value && imageAdventureRef.value) {
        buttonChallengeRef.value.classList.add(bgActiveClass);
        buttonAdventureRef.value.classList.remove(bgActiveClass);
        textChallengeRef.value.classList.remove("opacity-0");
        textChallengeRef.value.classList.add("opacity-1");
        textAdventureRef.value.classList.remove("opacity-1");
        textAdventureRef.value.classList.add("opacity-0");
        imageChallengeRef.value.classList.remove("hidden");
        imageChallengeRef.value.classList.add("visible");
        imageAdventureRef.value.classList.remove("visible");
        imageAdventureRef.value.classList.add("hidden");
    }
};

const handleAdventureClick = () => {
    if (buttonAdventureRef.value && buttonChallengeRef.value &&
        textAdventureRef.value && textChallengeRef.value &&
        imageChallengeRef.value && imageAdventureRef.value) {
        buttonChallengeRef.value.classList.remove(bgActiveClass);
        buttonAdventureRef.value.classList.add(bgActiveClass);
        textChallengeRef.value.classList.remove("opacity-1");
        textChallengeRef.value.classList.add("opacity-0");
        textAdventureRef.value.classList.add("opacity-1");
        textAdventureRef.value.classList.remove("opacity-0");
        imageChallengeRef.value.classList.add("hidden");
        imageChallengeRef.value.classList.remove("visible");
        imageAdventureRef.value.classList.add("visible");
        imageAdventureRef.value.classList.remove("hidden");
    }
};
</script>

<style scoped>
.font-emeritus {
    font-family: "Emeritus", sans-serif;
}

.font-league {
    font-family: "LeagueSpartan", sans-serif;
}

.image-challengen {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.image-challengen::-webkit-scrollbar {
    display: none;
}

.image-challengen img {
    display: inline-block;
}

.image-adventure {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.image-adventure:-webkit-scrollbar {
    display: none;
}

.image-adventure img {
    display: inline-block;
}
</style>